var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"learn-record-c"},[_c('h3',[_vm._v(_vm._s(_vm.$route.query.name)+"，在线学习共 "+_vm._s(_vm.values.length&&_vm.values.reduce((a,b)=>a+b))+" 分钟")]),_c('div',{ref:"recordCharts",staticStyle:{"width":"100%","height":"calc(100vh - 200px)"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }